import Summary from 'content/blog/vercel-like-developer-experience-summary';
import * as React from 'react';
export default {
  Summary,
  React
};